<template>
<div id="statslist" class="right-content">
  <el-form :model="filters" class="head-form">
    <el-row type="flex" justify="center" :gutter="20">
      <el-col :xs="6" :sm="6" :md="6" :lg="4">
        <el-form-item required>
            <el-form-item prop="event">
              <el-select v-model="filters.event" clearable placeholder="全部" @change="handleEventChange">
                <el-option
                  v-for="item in formatEvent"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
        </el-form-item>
      </el-col>

      <el-col :xs="6" :sm="6" :md="6" :lg="4">
        <el-form-item prop="user">
          <el-select v-model="filters.user" clearable placeholder="选择用户" @change="handleUserChange">
            <el-option
              v-for="item in formatUsers"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :xs="10" :sm="10" :md="10" :lg="6">
        <el-form-item prop="category">
          <el-date-picker
            v-model="filters.daterange"
            type="daterange"
            align="right"
            placeholder="选择日期范围"
            @change="handleDateRangeChange"
            :picker-options="pickerOptions1">
          </el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
  <el-row type="flex" justify="center" :gutter="20">
    <el-col :xs="24" :sm="24" :md="22" :lg="14">
      <el-table
        :data="formatEventData"
        v-loading="getLoadingStatus"
        element-loading-text="玩命加载中..."
        stripe
        style="width: 100%">
        <el-table-column
          prop="date"
          label="日期"
          width="180">
        </el-table-column>
        <el-table-column
          prop="detail"
          label="详细信息"
          min-width="460">
        </el-table-column>
      </el-table>

    </el-col>
  </el-row>

  <div class="nav-pagin">
    <el-row type="flex" justify="center">
      <el-col :xs="24" :sm="24" :md="22" :lg="14" class="el-item shadow">
        <el-pagination layout="total, prev, pager, next, jumper" :current-page.sync="page" @current-change="handlePageChange" :page-size="limit" :total="eventtotal">
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script type="text/javascript">
/**
 * 销售数据概览页组件
 */
import {mapGetters, mapActions} from 'vuex';
import { getNowTime, routeMap } from '../../utils/com.js'
import '../../static/style/stats/list.scss'
import { eventType } from '../../config/config'
import { Loading } from 'element-ui';

export default {
    data() {
        return {
            pickerOptions1: {
              disabledDate(time) {
                return time.getTime() > Date.now();
              },
              shortcuts: [{
                text: '最近一周',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近一个月',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近三个月',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                  picker.$emit('pick', [start, end]);
                }
              }]
            },
            filters: {
                event: '',
                daterange: '',
                start: '' || new Date().format("yyyy-MM-dd"),
                end: '' || new Date().format("yyyy-MM-dd"),
                user: '',
            },
            newloading: false,
            show: true,
            currentDate: new Date(),
            date: getNowTime(),
            page: 1,
            limit: 10,
            clientid: 1,
            type: null,
            users: null,
            // date: new Date().format("yyyy-MM-dd")
        }
    },
    created() {

      let curpage = this.$route.query.page || 1;
      this.page = parseInt(curpage);
      this.filters.event = this.$route.query.event || '';
      this.filters.start = this.$route.query.start || '';
      this.filters.end = this.$route.query.end || '';
      this.filters.user = this.$route.query.user || '';
      this.reqEventsChange();
      this.reqUserListData();
    },
    mounted() {
        console.debug("mounted");
        console.log(this.filters.daterange);
    },
    watch: {
        '$route' (to, from){
            let curpage = this.$route.query.page || 1;
            this.page = parseInt(curpage);
            this.filters.event = this.$route.query.event || '';
            this.filters.start = this.$route.query.start || '';
            this.filters.end = this.$route.query.end || '';
            this.filters.user = this.$route.query.user || '';
            this.reqEventsChange();
        }
    },
    computed: {
        ...mapGetters({
            // 映射 this.statsdata 为 store.getters.statsdata
            eventdata: 'eventdata',
            eventtotal: 'eventtotal',
            getLoadingStatus: 'getLoadingStatus',
        }),
        getStatsDataLen: function() {
            console.debug("getStatsDataLen> eventdata.length:%o", this.eventdata.length);
            return this.eventdata.length;
        },
        formatEvent(){
          let typelists = [];
          for(let i in eventType){
            let typelist = {}
            typelist.value = i;
            typelist.label = eventType[i];
            typelists.push(typelist);
          }
          console.debug("formatEvent> typelists:%o", typelists);
          return typelists;
        },
        formatUsers (){
          let userlists = [{value:'publisher', label:'publisher'}];
          for(let i in this.users){
            let userlist = {}
            userlist.value = this.users[i].user_name;
            userlist.label = this.users[i].user_name;
            userlists.push(userlist);
          }
          console.debug("formatUsers> userlists:%o", userlists);
          return userlists;
        },
        formatEventData () {
          // `this` points to the vm instance
          let lists = [];
          // console.debug("formatEventData> statsdata:%o", this.statsdata);
          for(let i in this.eventdata){
            let l = {};
            let newdata = this.eventdata[i];
            // console.debug("formatEventData> newdata:%o", newdata);
            l.id = newdata.id || 0;
            l.date = newdata.date || '';
            l.subject = newdata.subject || '';
            l.object = newdata.object || '';
            let sf = newdata.event || '';
            l.event = eventType[sf];
            l.detail =  l.subject + ' ' + l.event + ' ' + l.object //newdata.detail || '';
            // console.debug("formatEventData> newsData:%o, ls:%o", newdata, ls);
            lists.push(l);
          }
          console.debug("formatEventData> lists:%o", lists);
          return lists;
        }
    },
    methods: {
        ...mapActions({
          // 映射 this.getEditorData() 为 this.$store.dispatch('getEditorData')
          updateLoadingStatus: 'updateLoadingStatus',
          getConsoleEvent: 'getConsoleEvent',
          getUserList: 'getUserList',
        }),
        reqEventsChange() {
          var that = this;
          let param = {
              page: this.page,
              limit: this.limit,
              event: this.filters.event,
              start: this.filters.start || new Date().format("yyyy-MM-dd"),
              end: this.filters.end || new Date().format("yyyy-MM-dd"),
              user: this.filters.user,
          }
          console.debug("created> getConsoleEvent> param:%o", param);
          this.updateLoadingStatus(true);
          this.getConsoleEvent(param).then(
            (resp) => {
              this.updateLoadingStatus(false);
              console.debug("created> getConsoleEvent> resp:%o", resp);
              if(resp && resp.code !== 0){
                that.$message({
                      message: resp.msg,
                      type: 'error'
                  });
              }
            }
          );
        },
        reqUserListData() {
          var that = this;
            let param = {
                type: that.type
            }
            console.debug("reqUserListData> param:%o", param);
            that.updateLoadingStatus(true);
            that.getUserList(param).then(
              (resp) => {
                that.updateLoadingStatus(false);
                console.debug("reqUserListData> resp:%o, users:%o", resp, that.users);
                if(resp && resp.code !== 0){
                  that.$message({
                        message: resp.msg,
                        type: 'error'
                    });
                }else{
                    that.users = resp.data.users;
                }
              }
            );
        },
        handleDateRangeChange(val) {
          console.debug("handleDateRangeChange> val:%o, daterange:%o, start:%o, end:%o", val, this.filters.daterange, this.filters.start, this.filters.end);
          let datarange = val.split(' - ')
          this.filters.start = datarange[0]
          this.filters.end = datarange[1]
          console.debug("handleDateRangeChange> start:%o, end:%o", this.filters.start, this.filters.end);
          this.$router.push({ path: routeMap('/stats/events'), query: { page: this.page, event: this.filters.event, start: this.filters.start, end: this.filters.end, user: this.filters.user } });
          return;

          var that = this;
          let param = {
              page: this.page,
              limit: this.limit,
              event: this.filters.event,
              start: this.filters.start,
              end: this.filters.end,
              user: this.filters.user,
          }
          console.debug("created> getConsoleEvent> param:%o", param);
          this.updateLoadingStatus(true);
          this.getConsoleEvent(param).then(
            (resp) => {
              this.updateLoadingStatus(false);
              console.debug("created> getConsoleEvent> resp:%o", resp);
              if(resp && resp.code !== 0){
                that.$message({
                      message: resp.msg,
                      type: 'error'
                  });
              }
            }
          );

        },
        handlePageChange(val) {
          console.debug("handlePageChange> val:%o", val);
          this.$router.push({ path: routeMap('/stats/events'), query: { page: this.page, event: this.filters.event, start: this.filters.start, end: this.filters.end, user: this.filters.user } });
          return;

          if(this.page !== val){
            this.page = val;

            let param = {
                page: this.page,
                limit: this.limit,
                event: this.filters.event,
                start: this.filters.start,
                end: this.filters.end,
                user: this.filters.user,
            }
            console.debug("created> getConsoleEvent> param:%o", param);
            this.updateLoadingStatus(true);
            this.getConsoleEvent(param).then(
              (resp) => {
                this.updateLoadingStatus(false);
                console.debug("created> getConsoleEvent> resp:%o", resp);
                if(resp && resp.code !== 0){
                  that.$message({
                        message: resp.msg,
                        type: 'error'
                    });
                }
              }
            );
          }
        },
        handleEventChange(val){
          console.debug("handleEventChange> val:%o, event:%o", val, this.filters.event);
          this.$router.push({ path: routeMap('/stats/events'), query: { page: this.page, event: this.filters.event, start: this.filters.start, end: this.filters.end, user: this.filters.user } });
          return;

          let param = {
              page: this.page,
              limit: this.limit,
              event: this.filters.event,
              start: this.filters.start,
              end: this.filters.end,
              user: this.filters.user,
          }
          console.debug("created> getConsoleEvent> param:%o", param);
          this.updateLoadingStatus(true);
          this.getConsoleEvent(param).then(
            (resp) => {
              this.updateLoadingStatus(false);
              console.debug("created> getConsoleEvent> resp:%o", resp);
              if(resp && resp.code !== 0){
                that.$message({
                      message: resp.msg,
                      type: 'error'
                  });
              }
            }
          );

        },
        handleUserChange(val) {
            console.debug("handleUserChange> val:%o", val);
            this.$router.push({ path: routeMap('/stats/events'), query: { page: this.page, event: this.filters.event, start: this.filters.start, end: this.filters.end, user: this.filters.user } });
            return;

            var exp = new Date()
            exp.setTime(exp.getTime() + 1 * 24 * 60 * 60 * 1000)
            // 保存token
            cookie.save('ibroadcasteditor', this.filters.editor, {
                path: '/',
                expires: exp
            })
            // this.reqNewsListData();
            this.$router.push({ path: routeMap('/irecord/list'), query: { page: this.page, category: this.filters.category, editor: this.filters.editor } });
            console.debug("handlePageChange> query:%o, user:%o", this.$route.query, this.filters.editor);
        },

    },
}
</script>



// WEBPACK FOOTER //
// events.vue?f31f4dce